import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';

setupLogRocketReact(LogRocket);
LogRocket.init('ppbiel/radiofx');

export default LogRocket;
